module.exports = __webpack_public_path__ + "img/43cfcf6b4ece27f3a510f4b8e7560c36.png";